module.exports = __webpack_public_path__ + "img/bongabong-reference.e0e30b61.jpg";